import { useDeleteAtmType } from "./api/deleteAtmType";
import { Button } from "reactstrap";


const DeleteAtmType = ({handleCloseModal, atmTypeId}: DeleteAtmTypeProps)  => {
  
  const deleteAtmTypeMutation = useDeleteAtmType({ atmTypeId});
  const handleSubmit = async (): Promise<void> => {
    deleteAtmTypeMutation.mutateAsync({ 
      atmTypeId: atmTypeId
    })

    handleCloseModal();
  }

  return (
    <>
        <label>Είστε σίγουροι οτι θέλετε να διαγράψετε τον Τύπο;</label>
        <div>
          <Button style={{ margin: "10px" }} onClick={handleCloseModal}>Ακύρωση</Button>
          <Button style={{ margin: "10px" }} color='danger' onClick={handleSubmit}>Διαγραφή</Button>
        </div>
    </>
  )
}

interface DeleteAtmTypeProps{
  atmTypeId: number;
  handleCloseModal: () => void;
}

export default DeleteAtmType;